import { jsx } from "react/jsx-runtime";
import assert from "assert";
import { Children } from "react";
import { flattenChildren } from "../../utils/flattenChildren.mjs";
import { Box } from "../Box/Box.mjs";
import { negativeMargin } from "../../css/negativeMargin/negativeMargin.mjs";
import { resolveCollapsibleAlignmentProps } from "../../utils/collapsibleAlignmentProps.mjs";
import { buildDataAttributes } from "../private/buildDataAttributes.mjs";
const validInlineComponents = ["div", "span", "ol", "ul"];
const Inline = ({
  space = "none",
  align,
  alignY,
  collapseBelow,
  reverse,
  component = "div",
  data,
  children,
  ...restProps
}) => {
  assert(
    validInlineComponents.includes(component),
    `Invalid Inline component: '${component}'. Should be one of [${validInlineComponents.map((c) => `'${c}'`).join(", ")}]`
  );
  const isList = component === "ol" || component === "ul";
  const inlineItemComponent = isList ? "li" : component;
  const {
    collapsibleAlignmentProps,
    collapsibleAlignmentChildProps,
    orderChildren
  } = resolveCollapsibleAlignmentProps({
    align,
    alignY,
    collapseBelow,
    reverse
  });
  return /* @__PURE__ */ jsx(
    Box,
    {
      component: component === "span" ? component : void 0,
      display: component === "span" ? "block" : void 0,
      className: negativeMargin("top", space),
      ...buildDataAttributes({ data, validateRestProps: restProps }),
      children: /* @__PURE__ */ jsx(
        Box,
        {
          component,
          className: negativeMargin("left", space),
          flexWrap: "wrap",
          ...collapsibleAlignmentProps,
          children: Children.map(
            orderChildren(flattenChildren(children)),
            (child) => child !== null && child !== void 0 ? /* @__PURE__ */ jsx(
              Box,
              {
                component: inlineItemComponent,
                minWidth: 0,
                marginLeft: space,
                marginTop: space,
                ...collapsibleAlignmentChildProps,
                children: child
              }
            ) : null
          )
        }
      )
    }
  );
};
export {
  Inline,
  validInlineComponents
};
